import { AccessControlProvider } from "@refinedev/core";
import { authProvider } from "./authProvider";
import { UserRole } from "./models/role";

const AuthUrls = [
    "/login",
    "/register",
    "/confirm-email",
    "/forgot-password",
    "/reset-password",
    "/signup",
    "/activate-tenant",
    "/resend-activation",
];

export function isAuthUrl(url: string): boolean {
    return AuthUrls.some(item => url.includes(item));
}

export const accessControlProvider: AccessControlProvider = {
    can: async ({ action, resource, params }) => {

        const role = await authProvider.getPermissions?.();
        //console.log("accessControlProvider - User role", role, resource, action, params);


        if (isAuthUrl(window.location.pathname)) {
            return {
                can: true,
            };
        }

        if (!role || role == '') {
            if (window.location.pathname !== "/login")
                window.location.href = "/login";
            return {
                can: false,
                reason: "No roles found",
            };
        }

        //console.log("accessControlProvider - User role", role, resource, action, params);
        
        if (role == UserRole.admin || role == UserRole.superAdmin) {
            /*if (resource == "users" && action == "create") {
                return {
                    can: false,
                };
            }*/
            // Tenants are only accessible to super admins
            if (resource == "tenants") {
                if (role == UserRole.superAdmin) {
                    return {
                        can: true,
                    };
                } else {
                    return {
                        can: false,
                        reason: "Only super admins can access tenants",
                    };
                }
            }
            return {
                can: true,
            };
        }
        if (role == UserRole.user) {
            // Clinent view
            //console.log("accessControlProvider", action, resource, params);
            //console.log("accessControlProvider", params);
            if (
                resource == "account-home"
                || resource == "orders"
                || resource == "tarifs"
                || resource == "transactions"
                || resource == "settings"
            ) {
                //console.log("accessControlProvider - Access granted", resource, action, params);
                return {
                    can: true,
                };
                
            } else {
                //window.location.href = "/account-home";
            }
        }
        // Tuner view
        if (role == UserRole.tuner) {
            if (resource == "orders") {
                return {
                    can: true,
                };
            }
        }

        //console.log("accessControlProvider - Access denied", resource, action, params);

        return {
            can: false,
            reason: "Unauthorized",
        };
    },
    options: {
        buttons: {
            enableAccessControl: false,
            hideIfUnauthorized: true,
        }
    }

};

